import { Linking, StyleSheet, View } from "react-native";
import { useTheme } from "../../hooks/use-theme";
import VStack from "../../ui_atoms/VStack";
import { useCallback } from "react";
import { useI18n } from "../../hooks/i18n-hooks";
import Button from "../../components/Button";
import LogoImage from "../../assets/images/logo.svg";
import BlurView from "../../components/BlurView";
import { LinearGradient } from "expo-linear-gradient";
import { BodyMediumText, TitleLargeText } from "../../components/FormattedText";
import HStack from "../../ui_atoms/HStack";
import Constants from "expo-constants";

const graphqlUrl = Constants.expoConfig?.extra?.graphQLUrl as string;
const appUrl = graphqlUrl.replace("graphql", "app");

const EmailVerifiedError = () => {
    const { colors } = useTheme();
    const i18n = useI18n();

    const openApp = useCallback(() => {
        if (appUrl) {
            void Linking.openURL(appUrl);
        }
    }, []);

    const LIFT_LOGO_HEIGHT = 83.56;

    return (
        <View style={{ flex: 1 }}>
            <BlurView blurRadius={6} />
            <LinearGradient
                start={{ x: 0.55, y: 0.55 }}
                end={{ x: 1, y: 0.4 }}
                locations={[0.5, 0.8]}
                colors={[colors.brightGrey, colors.quaternary]}
                style={[StyleSheet.absoluteFill, { opacity: 0.8 }]}
            />
            <VStack
                alignment="center"
                gap={1}
                left={1}
                right={1}
                style={{ flex: 1, justifyContent: "center" }}
            >
                <LogoImage height={LIFT_LOGO_HEIGHT} width={114} />
                <TitleLargeText>{i18n.t("screens.auth.email_verified.error.title")}</TitleLargeText>
                <BodyMediumText style={{ textAlign: "center" }}>
                    {i18n.t("screens.auth.email_verified.error.description")}
                </BodyMediumText>
                <HStack>
                    <Button
                        label={i18n.t("screens.auth.email_verified.open_app")}
                        onPress={openApp}
                        buttonMode="primary"
                    />
                </HStack>
            </VStack>
        </View>
    );
};

export default EmailVerifiedError;
